
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28703",
  depVersions: {
  "payments-ui-app": "static-1.28703",
  "bend-plugin-arboretum": "static-1.2017",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "crm_data": "static-4.93201",
  "data-fetching-client": "static-1.10114",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8747",
  "foundations-components-legacy": "static-1.1772",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6066",
  "hs-test-utils": "static-1.8512",
  "hub-http": "static-1.6680",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11961",
  "I18n": "static-7.1707",
  "jasmine-runner": "static-1.6925",
  "quartz": "static-1.7657",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5656",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6098",
  "UIComponents": "static-3.8907",
  "usage-tracker-public": "static-1.7608",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38051",
  "payments-checkout-lib": "static-1.626",
  "cssUtils": "static-1.1096",
  "customer-data-objects": "static-1.8176",
  "FireAlarmUi": "static-1.4862",
  "foundations-assets": "static-1.5359",
  "foundations-theming": "static-1.4961",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12268",
  "icons": "static-2.702",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3358",
  "property-translator": "static-1.5853",
  "quartz-config": "static-1.1435",
  "quartz-core": "static-1.6876",
  "quartz-i18n": "static-1.1332",
  "quartz-routing": "static-1.1087",
  "quartz-tracking": "static-1.1036",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17208",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10844",
  "rpc-client-utils": "static-1.5143",
  "sanitize-text": "static-1.8631",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5233",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11619",
  "ui-images": "static-2.1276",
  "usage-tracker-core": "static-1.7647",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3934",
  "quartz-webpack": "static-1.3881",
  "bend-plugin-quartz-routing": "static-1.735",
  "bender-build-tools": "static-1.3578",
  "crm_universal": "static-1.22724",
  "customer-data-email": "static-1.18639",
  "customer-data-ui-utilities": "static-1.10307",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8394",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8237",
  "quick-fetch": "static-1.4230",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5016",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2677",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9897",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.102",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3081",
  "ui-fonts": "static-1.1223",
  "HeadJS": "static-2.821",
  "hs-test-utils-bend-plugin": "static-1.3623",
  "msw": "static-1.102",
  "msw-config": "static-1.28",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.400",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4781",
  "foundations-components-test-utils": "static-1.6230",
  "ui-addon-draggable": "static-3.5222",
  "commerce-billing-lib": "static-1.20487",
  "commerce-shared-components-lib": "static-1.19564",
  "commerce-tools-ui-lib": "static-1.11320",
  "crm-message-bus": "static-1.44103",
  "customer-data-objects-ui-components": "static-1.13509",
  "customer-data-properties": "static-1.53036",
  "growth-payments-core": "static-1.26499",
  "ui-addon-iframeable": "static-1.9548",
  "usage-tracker": "static-1.7797",
  "usage-tracker-container": "static-1.7787",
  "sassPrefix": "static-1.362",
  "inbound-db-properties-service-client": "static-1.4151",
  "foundations-theming-base": "static-1.3946",
  "bend-plugin-foundations-theming": "static-1.3444",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.265",
  "hub-http-janus": "static-1.906",
  "hubspotter-http": "static-1.4975",
  "mobile-manifest-mixins": "static-1.605",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.640",
  "quartz-auth": "static-1.1332",
  "quartz-head": "static-1.1322",
  "quartz-test": "static-1.1332",
  "trellis-components": "static-1.3100",
  "usage-tracker-session-replay": "static-1.5483",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.174",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.553",
  "chirp-fetch": "static-1.2378",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4948",
  "FormUrlGenerator": "static-2.5188",
  "sequences-lib": "static-1.8778",
  "apollo-link-hub-http": "static-2.5061",
  "FileManagerCore": "static-1.40339",
  "FileManagerLib": "static-1.40480",
  "hubspot-apollo-client": "static-1.5354",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.731",
  "timezone-utils": "static-2.5703",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5083",
  "stylex-utils": "static-1.174",
  "trellis-theming": "static-1.1474",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2961",
  "hs-resources": "static-1.667",
  "pulse": "static-1.1119",
  "utility-belt": "static-1.3011",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2021",
  "customer-data-associations": "static-1.7811",
  "customer-data-property-utils": "static-1.8524",
  "customer-data-tracking": "static-1.7343",
  "framework-data-schema-resolvers": "static-1.7365",
  "framework-data-table": "static-2.12836",
  "object-builder-ui-client": "static-1.50045",
  "payments-enrollment-embed-lib": "static-1.24191",
  "stripe-embedded-components": "static-1.8244",
  "ui-addon-opt": "static-4.8879",
  "ai-components-ui-library": "static-1.10016",
  "customer-data-rte": "static-1.33899",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24840",
  "growth-onboarding-confetti": "static-1.3532",
  "growth-onboarding-empty-states": "static-1.6532",
  "hubspot-prosemirror": "static-1.19279",
  "InboxConnectUtils": "static-4.15842",
  "payment-link-components": "static-1.24454",
  "payments-post-enroll-local-storage-lib": "static-1.5578",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39167",
  "react-colorpicker": "static-2.10683",
  "ui-addon-upgrades": "static-9.18547",
  "ui-addon-video-player": "static-1.9097",
  "user-context": "static-1.5527",
  "restore-request-side-panel-lib": "static-1.2032",
  "atom": "static-1.5546",
  "reference-resolvers": "static-1.8656",
  "calling-global-api": "static-1.66186",
  "calling-internal-common": "static-1.31799",
  "calling-lifecycle-internal": "static-1.67568",
  "calling-lifecycle-messages": "static-1.59861",
  "commerce-products-lib": "static-1.10914",
  "conditional-properties-service-client": "static-1.4113",
  "crm-index-visualization-core": "static-1.4755",
  "crm-links": "static-1.6782",
  "crm-pipelines-api-client-types": "static-1.4443",
  "customer-data-properties-shared-msw-handlers": "static-1.10227",
  "external-options-client-types": "static-1.4439",
  "formula-editor": "static-1.15010",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3774",
  "inbounddb-objects-service-types": "static-1.4520",
  "meetings-icalendar-utils-lib": "static-1.1107",
  "multi-currency-client-types": "static-1.4007",
  "pipeline-validation-client-types": "static-1.4281",
  "property-value-citations": "static-1.3650",
  "reference-resolvers-lite": "static-1.8584",
  "smart-data-capture-core": "static-1.470",
  "smart-property-lib": "static-1.8653",
  "tiered-pricing": "static-1.2270",
  "topics-actions-lib": "static-1.657",
  "trellis-ext-i18n": "static-1.1387",
  "trial-components-library": "static-1.14373",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7620",
  "onboarding-scopes": "static-1.6926",
  "seat-types-lib": "static-1.1050",
  "magpie-lib": "static-1.5906",
  "navigation-messaging": "static-1.8492",
  "ts-schema": "static-1.4392",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10900",
  "hubspotter-http-shared-msw-handlers": "static-1.10898",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8635",
  "audio-components": "static-1.6569",
  "breeze-artifacts-sdk": "static-1.936",
  "ContentUtils": "static-1.69467",
  "copilot-toolkit": "static-1.12146",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30060",
  "FileManagerImages": "static-1.37991",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4615",
  "ui-universal-auth": "static-1.9740",
  "urlinator": "static-1.4988",
  "video-components": "static-1.14430",
  "video-data-lib": "static-1.36086",
  "video-embed": "static-1.36920",
  "hubspot-apollo-cache": "static-1.813",
  "trellis-migration-context": "static-1.53",
  "event-emitter": "static-1.1435",
  "fdsr-migration-layer": "static-1.484",
  "framework-builder-read-service-client": "static-1.4334",
  "bend-plugin-pulse": "static-1.622",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7270",
  "persist-promise": "static-1.4178",
  "customer-data-reference-ui-components": "static-1.13648",
  "reporting-data": "static-1.69344",
  "tasks-actions-lib": "static-1.430",
  "purchase-motions-components": "static-1.6628",
  "growth-onboarding-feedback-components": "static-1.7056",
  "growth-onboarding-reliability": "static-1.5557",
  "marketplace-ui-apps-core": "static-1.19581",
  "onboarding-tours": "static-1.17402",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23876",
  "content-assistance-lib": "static-1.8421",
  "draft-content-plugins": "static-1.29154",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22355",
  "rich-text-lib": "static-1.20552",
  "breeze-engine-lib": "static-1.2170",
  "poll-commands": "static-1.3951",
  "video-components-external": "static-1.12428",
  "trellis-story-utils": "static-1.4971",
  "ui-addon-react-router-dom": "static-1.10000",
  "content-media-capture": "static-1.5786",
  "knowledge-content-types": "static-1.8762",
  "ui-addon-emoji-picker": "static-1.10337",
  "ui-business-units-lib": "static-1.9569",
  "ui-shepherd-react": "static-3.10752",
  "hub-http-contrib": "static-1.3505",
  "ui-addon-sales-email": "static-1.5675",
  "commerce-tours-lib": "static-1.6861",
  "getting-started-shared-tasks": "static-1.19560",
  "sales-checkout-service-client": "static-1.3998",
  "merchandise-lib": "static-1.284",
  "getting-started-shared-tasks-store": "static-1.18678",
  "onboarding-tours-utils": "static-1.1469",
  "calling-error-reporting": "static-1.31806",
  "shared-worker-versioning": "static-1.11514",
  "calling-usage-tracker": "static-1.7012",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2437",
  "commerce-permissions": "static-1.1258",
  "products-iframe-lib": "static-1.8905",
  "products-ui-components-shared-msw-handlers": "static-1.11282",
  "crm-index-associations-lib": "static-1.6922",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10983",
  "sales-views-client-types": "static-1.4730",
  "location-customization-utils-lib": "static-1.10417",
  "bark-lib": "static-1.17004",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6368",
  "react-codemirror": "static-1.11115",
  "data-agent-kit": "static-1.914",
  "data-agent-test-utils": "static-1.458",
  "data-agent-utils": "static-1.927",
  "data-token-picker": "static-1.17132",
  "fsm": "static-1.4231",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56269",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11046",
  "tinymce-config": "static-2.55395",
  "tinymce-plugins": "static-1.58509",
  "embedded-academy-lib": "static-1.16002",
  "hubs-service-types": "static-1.1741",
  "navigation-components": "static-1.19165",
  "nest": "static-1.707",
  "nudge-client-utils": "static-1.3417",
  "purchase-motions-api": "static-1.6631",
  "signup-constants": "static-1.19941",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5366",
  "reactive-lib": "static-1.1192",
  "simple-logging-lib": "static-1.3524",
  "nav-meta": "static-1.30802",
  "breeze-engine-core": "static-1.1448",
  "cms-field-types": "static-1.5284",
  "content-icons-ui": "static-1.2455",
  "integrations-lib": "static-1.17429",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.304",
  "unified-auth-core-lib": "static-1.1536",
  "social-insights-client-types": "static-1.22928",
  "outpost": "static-1.4601",
  "reporting-client-types": "static-1.2834",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11012",
  "immutable-less": "static-1.5126",
  "marketplace-ui-client-types": "static-1.18456",
  "marketplace-ui-common": "static-1.21049",
  "ui-addon-integrations-directory-panel": "static-2.8426",
  "ui-extensibility-client-types": "static-1.4389",
  "growth-data-modal": "static-1.6132",
  "growth-onboarding-next-action-utils": "static-1.2981",
  "onboarding-tours-client": "static-1.5617",
  "ui-shepherd-tracker": "static-1.8133",
  "ui-coaching-tips": "static-1.29582",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1148",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13590",
  "content-media-compositions": "static-2.17597",
  "media-bridge-lib": "static-1.19640",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4900",
  "calling-orchestration-schema": "static-1.37214",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16667",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.233",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57365",
  "interframe": "static-3.5214",
  "tinymce-data": "static-1.41480",
  "layout-dnd-components": "static-1.13226",
  "layout-dnd-utils": "static-1.12201",
  "ui-brand-identity-lib": "static-1.16943",
  "academy-common-lib": "static-1.15463",
  "nudge-custom-function-registry": "static-1.3174",
  "nudge-renderer-utils": "static-1.3493",
  "whisper-core-api": "static-1.7634",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14844",
  "integrations-tracking-lib": "static-1.6093",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4611",
  "ai-settings-ui-library": "static-1.8580",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1578",
  "onboarding-data-sync-lib": "static-1.2838",
  "growth-onboarding-next-action-components": "static-1.3009",
  "user-context-client": "static-1.4983",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9366",
  "ContentData": "static-1.69542",
  "layout-data-lib": "static-1.10526",
  "academy-service-client": "static-1.4165",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4870",
  "trellis-ecosystem": "static-1.7847",
  "wootric-nps": "static-1.7296",
  "universal-page-editor-lib": "static-1.3483",
  "settings-ui-lib": "static-1.13000",
  "simple-data-table": "static-1.3819",
  "meetings-connect-utils-lib": "static-1.8092",
  "advanced-menus-core": "static-1.15814",
  "advanced-menus-lib": "static-1.12568",
  "ExportDialog": "static-6.10848",
  "ui-memberships-settings-lib": "static-1.35189",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15813",
  "simple-menus-lib": "static-1.17330"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28703",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2017",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "crm_data": "/crm_data/static-4.93201",
  "data-fetching-client": "/data-fetching-client/static-1.10114",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8747",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1772",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6066",
  "hs-test-utils": "/hs-test-utils/static-1.8512",
  "hub-http": "/hub-http/static-1.6680",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11961",
  "I18n": "/I18n/static-7.1707",
  "jasmine-runner": "/jasmine-runner/static-1.6925",
  "quartz": "/quartz/static-1.7657",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5656",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6098",
  "UIComponents": "/UIComponents/static-3.8907",
  "usage-tracker-public": "/usage-tracker-public/static-1.7608",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38051",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.626",
  "cssUtils": "/cssUtils/static-1.1096",
  "customer-data-objects": "/customer-data-objects/static-1.8176",
  "FireAlarmUi": "/FireAlarmUi/static-1.4862",
  "foundations-assets": "/foundations-assets/static-1.5359",
  "foundations-theming": "/foundations-theming/static-1.4961",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12268",
  "icons": "/icons/static-2.702",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3358",
  "property-translator": "/property-translator/static-1.5853",
  "quartz-config": "/quartz-config/static-1.1435",
  "quartz-core": "/quartz-core/static-1.6876",
  "quartz-i18n": "/quartz-i18n/static-1.1332",
  "quartz-routing": "/quartz-routing/static-1.1087",
  "quartz-tracking": "/quartz-tracking/static-1.1036",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17208",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10844",
  "rpc-client-utils": "/rpc-client-utils/static-1.5143",
  "sanitize-text": "/sanitize-text/static-1.8631",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5233",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11619",
  "ui-images": "/ui-images/static-2.1276",
  "usage-tracker-core": "/usage-tracker-core/static-1.7647",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3934",
  "quartz-webpack": "/quartz-webpack/static-1.3881",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.735",
  "bender-build-tools": "/bender-build-tools/static-1.3578",
  "crm_universal": "/crm_universal/static-1.22724",
  "customer-data-email": "/customer-data-email/static-1.18639",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10307",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8394",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8237",
  "quick-fetch": "/quick-fetch/static-1.4230",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5016",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2677",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9897",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.102",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3081",
  "ui-fonts": "/ui-fonts/static-1.1223",
  "HeadJS": "/HeadJS/static-2.821",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3623",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.28",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.400",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4781",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6230",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5222",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20487",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19564",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11320",
  "crm-message-bus": "/crm-message-bus/static-1.44103",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13509",
  "customer-data-properties": "/customer-data-properties/static-1.53036",
  "growth-payments-core": "/growth-payments-core/static-1.26499",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9548",
  "usage-tracker": "/usage-tracker/static-1.7797",
  "usage-tracker-container": "/usage-tracker-container/static-1.7787",
  "sassPrefix": "/sassPrefix/static-1.362",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4151",
  "foundations-theming-base": "/foundations-theming-base/static-1.3946",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3444",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.265",
  "hub-http-janus": "/hub-http-janus/static-1.906",
  "hubspotter-http": "/hubspotter-http/static-1.4975",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.605",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.640",
  "quartz-auth": "/quartz-auth/static-1.1332",
  "quartz-head": "/quartz-head/static-1.1322",
  "quartz-test": "/quartz-test/static-1.1332",
  "trellis-components": "/trellis-components/static-1.3100",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5483",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.174",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.553",
  "chirp-fetch": "/chirp-fetch/static-1.2378",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4948",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5188",
  "sequences-lib": "/sequences-lib/static-1.8778",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5061",
  "FileManagerCore": "/FileManagerCore/static-1.40339",
  "FileManagerLib": "/FileManagerLib/static-1.40480",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5354",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.731",
  "timezone-utils": "/timezone-utils/static-2.5703",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5083",
  "stylex-utils": "/stylex-utils/static-1.174",
  "trellis-theming": "/trellis-theming/static-1.1474",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2961",
  "hs-resources": "/hs-resources/static-1.667",
  "pulse": "/pulse/static-1.1119",
  "utility-belt": "/utility-belt/static-1.3011",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2021",
  "customer-data-associations": "/customer-data-associations/static-1.7811",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8524",
  "customer-data-tracking": "/customer-data-tracking/static-1.7343",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7365",
  "framework-data-table": "/framework-data-table/static-2.12836",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50045",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24191",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8244",
  "ui-addon-opt": "/ui-addon-opt/static-4.8879",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10016",
  "customer-data-rte": "/customer-data-rte/static-1.33899",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24840",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3532",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6532",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19279",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15842",
  "payment-link-components": "/payment-link-components/static-1.24454",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5578",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39167",
  "react-colorpicker": "/react-colorpicker/static-2.10683",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9097",
  "user-context": "/user-context/static-1.5527",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2032",
  "atom": "/atom/static-1.5546",
  "reference-resolvers": "/reference-resolvers/static-1.8656",
  "calling-global-api": "/calling-global-api/static-1.66186",
  "calling-internal-common": "/calling-internal-common/static-1.31799",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67568",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59861",
  "commerce-products-lib": "/commerce-products-lib/static-1.10914",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4113",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4755",
  "crm-links": "/crm-links/static-1.6782",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4443",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10227",
  "external-options-client-types": "/external-options-client-types/static-1.4439",
  "formula-editor": "/formula-editor/static-1.15010",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3774",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4520",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1107",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4007",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4281",
  "property-value-citations": "/property-value-citations/static-1.3650",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8584",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.470",
  "smart-property-lib": "/smart-property-lib/static-1.8653",
  "tiered-pricing": "/tiered-pricing/static-1.2270",
  "topics-actions-lib": "/topics-actions-lib/static-1.657",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1387",
  "trial-components-library": "/trial-components-library/static-1.14373",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7620",
  "onboarding-scopes": "/onboarding-scopes/static-1.6926",
  "seat-types-lib": "/seat-types-lib/static-1.1050",
  "magpie-lib": "/magpie-lib/static-1.5906",
  "navigation-messaging": "/navigation-messaging/static-1.8492",
  "ts-schema": "/ts-schema/static-1.4392",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10900",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10898",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8635",
  "audio-components": "/audio-components/static-1.6569",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.936",
  "ContentUtils": "/ContentUtils/static-1.69467",
  "copilot-toolkit": "/copilot-toolkit/static-1.12146",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30060",
  "FileManagerImages": "/FileManagerImages/static-1.37991",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4615",
  "ui-universal-auth": "/ui-universal-auth/static-1.9740",
  "urlinator": "/urlinator/static-1.4988",
  "video-components": "/video-components/static-1.14430",
  "video-data-lib": "/video-data-lib/static-1.36086",
  "video-embed": "/video-embed/static-1.36920",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.813",
  "trellis-migration-context": "/trellis-migration-context/static-1.53",
  "event-emitter": "/event-emitter/static-1.1435",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.484",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4334",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.622",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7270",
  "persist-promise": "/persist-promise/static-1.4178",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13648",
  "reporting-data": "/reporting-data/static-1.69344",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.430",
  "purchase-motions-components": "/purchase-motions-components/static-1.6628",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7056",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5557",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19581",
  "onboarding-tours": "/onboarding-tours/static-1.17402",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23876",
  "content-assistance-lib": "/content-assistance-lib/static-1.8421",
  "draft-content-plugins": "/draft-content-plugins/static-1.29154",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22355",
  "rich-text-lib": "/rich-text-lib/static-1.20552",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2170",
  "poll-commands": "/poll-commands/static-1.3951",
  "video-components-external": "/video-components-external/static-1.12428",
  "trellis-story-utils": "/trellis-story-utils/static-1.4971",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10000",
  "content-media-capture": "/content-media-capture/static-1.5786",
  "knowledge-content-types": "/knowledge-content-types/static-1.8762",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10337",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9569",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10752",
  "hub-http-contrib": "/hub-http-contrib/static-1.3505",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5675",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6861",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19560",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3998",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18678",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1469",
  "calling-error-reporting": "/calling-error-reporting/static-1.31806",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11514",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7012",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2437",
  "commerce-permissions": "/commerce-permissions/static-1.1258",
  "products-iframe-lib": "/products-iframe-lib/static-1.8905",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11282",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6922",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10983",
  "sales-views-client-types": "/sales-views-client-types/static-1.4730",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10417",
  "bark-lib": "/bark-lib/static-1.17004",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6368",
  "react-codemirror": "/react-codemirror/static-1.11115",
  "data-agent-kit": "/data-agent-kit/static-1.914",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.458",
  "data-agent-utils": "/data-agent-utils/static-1.927",
  "data-token-picker": "/data-token-picker/static-1.17132",
  "fsm": "/fsm/static-1.4231",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56269",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11046",
  "tinymce-config": "/tinymce-config/static-2.55395",
  "tinymce-plugins": "/tinymce-plugins/static-1.58509",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16002",
  "hubs-service-types": "/hubs-service-types/static-1.1741",
  "navigation-components": "/navigation-components/static-1.19165",
  "nest": "/nest/static-1.707",
  "nudge-client-utils": "/nudge-client-utils/static-1.3417",
  "purchase-motions-api": "/purchase-motions-api/static-1.6631",
  "signup-constants": "/signup-constants/static-1.19941",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5366",
  "reactive-lib": "/reactive-lib/static-1.1192",
  "simple-logging-lib": "/simple-logging-lib/static-1.3524",
  "nav-meta": "/nav-meta/static-1.30802",
  "breeze-engine-core": "/breeze-engine-core/static-1.1448",
  "cms-field-types": "/cms-field-types/static-1.5284",
  "content-icons-ui": "/content-icons-ui/static-1.2455",
  "integrations-lib": "/integrations-lib/static-1.17429",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.304",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1536",
  "social-insights-client-types": "/social-insights-client-types/static-1.22928",
  "outpost": "/outpost/static-1.4601",
  "reporting-client-types": "/reporting-client-types/static-1.2834",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11012",
  "immutable-less": "/immutable-less/static-1.5126",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18456",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21049",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8426",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4389",
  "growth-data-modal": "/growth-data-modal/static-1.6132",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2981",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5617",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8133",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29582",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1148",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13590",
  "content-media-compositions": "/content-media-compositions/static-2.17597",
  "media-bridge-lib": "/media-bridge-lib/static-1.19640",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4900",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37214",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16667",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.233",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57365",
  "interframe": "/interframe/static-3.5214",
  "tinymce-data": "/tinymce-data/static-1.41480",
  "layout-dnd-components": "/layout-dnd-components/static-1.13226",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12201",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16943",
  "academy-common-lib": "/academy-common-lib/static-1.15463",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3174",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3493",
  "whisper-core-api": "/whisper-core-api/static-1.7634",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14844",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6093",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4611",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8580",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1578",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2838",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3009",
  "user-context-client": "/user-context-client/static-1.4983",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9366",
  "ContentData": "/ContentData/static-1.69542",
  "layout-data-lib": "/layout-data-lib/static-1.10526",
  "academy-service-client": "/academy-service-client/static-1.4165",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4870",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7847",
  "wootric-nps": "/wootric-nps/static-1.7296",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3483",
  "settings-ui-lib": "/settings-ui-lib/static-1.13000",
  "simple-data-table": "/simple-data-table/static-1.3819",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8092",
  "advanced-menus-core": "/advanced-menus-core/static-1.15814",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12568",
  "ExportDialog": "/ExportDialog/static-6.10848",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35189",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15813",
  "simple-menus-lib": "/simple-menus-lib/static-1.17330"
}
};
